import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3 items-center w-full" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-16 w-20 text-yellow-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z\"></path></svg></div><div class=\"flex justify-center py-2\"><span class=\"text-xl w-full text-center font-semibold\"> Are you sure to remove this candidate? </span></div>", 2)
const _hoisted_4 = { class: "flex flex-row justify-around rounded-full py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
        class: "px-5 py-2 border-2 border-primary rounded-full"
      }, " Cancel "),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
        class: "px-5 py-2 bg-primary text-white rounded-full"
      }, " Confirm ")
    ])
  ]))
}